import axios from "axios";
import config  from '../../env.json';
function getRNData(payload:any,callback:any){
    try {
        axios({
          method: 'get',
          url:config.REACT_APP_ENV_API_BASE+"/flowbuilder/getFlowbuilderStructure",
          params:payload
        }) 
        .then(res=>{
          if(res.data) 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}

function createFlow(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/insert',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function createDeployment(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/v2/flowbuilder/extract',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function triggerTerraFormPipeline(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/pipe/runsinglepipeline',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function updateFlow(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/update',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function updateConfirmation(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/updateConfirmation',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function getFlow(payload:any,callback:any){
  try {
    axios({
      method: 'get',
      //url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/getFlowbuilderStructureSelected'
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/getFlowbuilderStructureSelected/'+payload.Client_Id+'/'+payload.Env_Id,
    })  
      .then(res=>{
        if(res.data)
        callback([{Flow_Builder_Object:res.data}]);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}

function getAllClientsApi(callback:any){
  try {
      axios.get(config.REACT_APP_ENV_API_BASE+"/client/allclientdetails")
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}


  function getEnvsDataApi(payload:any,callback:any){
    try {
      axios({
        method: 'get',
        url:config.REACT_APP_ENV_API_BASE+"/env/envdetails/"+payload.Client_Id,
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}

  function getFBJsonKeys(callback:any){
    try {
      axios({
        method: 'get',
        url:config.REACT_APP_ENV_API_BASE+"/flowbuilder/getFBDataJSON",
      })  
        .then(res=>{ 
          callback(res.data);
        }).catch(()=>{
          callback(null)
        })
    } catch (error) {
        callback(null)
    }
   
}
 


function createFBJsonKey(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/insertFBDataJSON',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function updateFBJsonKey(payload:any,callback:any){
  try {
    axios({
      method: 'post',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/updateFBDataJSON',
      data:payload
    })  
      .then(res=>{ 
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
 

function getDefaultFlow(callback:any){
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/flowbuilder/getFlowbuilderStructuredefault',
    })  
      .then(res=>{
        if(res.data)
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}
function getEnvList(payload:any,callback:any){
  try {
    axios({
      method: 'get',
      url:config.REACT_APP_ENV_API_BASE+'/env/envdetails',
      params:payload
    })  
      .then(res=>{
        if(res.data)
        callback(res.data);
      }).catch(()=>{
        callback(null)
      })
  } catch (error) {
      callback(null)
  }
 
}

export {getEnvList,getDefaultFlow,getRNData,createFlow,getAllClientsApi,getEnvsDataApi,getFlow,updateFlow,createDeployment,triggerTerraFormPipeline,getFBJsonKeys,createFBJsonKey,updateFBJsonKey,updateConfirmation}